const type = 'SET_CARD_TEMPORARY_BLOCK_OUTCOME';

const setCardTemporaryBlockOutcome = (data) => ({
  data,
  type,
});

export { type };
export default setCardTemporaryBlockOutcome;
